import React, { useState } from 'react';
import Modal from '../../../../components/common/Modal';
import Button from '../../../../components/common/Button';
import Input from '../../../../components/common/Input';
import Textarea from '../../../../components/common/Textarea';
import { supabase } from '../../../../supabase';
import styles from './EditIdeaModal.module.css';

function EditIdeaModal({ isOpen, onClose, idea, onSuccess }) {
  const [formData, setFormData] = useState({
    title: idea?.title || '',
    problem: idea?.problem || '',
    solution: idea?.solution || '',
    impact: idea?.impact || ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const { error } = await supabase
        .from('ideas')
        .update(formData)
        .eq('id', idea.id);

      if (error) throw error;

      onSuccess();
    } catch (error) {
      console.error('Error updating idea:', error);
      alert('아이디어 수정 중 오류가 발생했습니다.');
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="아이디어 수정">
      <form onSubmit={handleSubmit} className={styles.form}>
        <div className={styles.formGroup}>
          <Input
            label="제목"
            id="title"
            name="title"
            value={formData.title}
            onChange={handleChange}
            placeholder="아이디어의 제목을 입력해주세요"
          />
        </div>

        <div className={styles.formGroup}>
          <Textarea
            label="문제"
            id="problem"
            name="problem"
            value={formData.problem}
            onChange={handleChange}
            placeholder="해결하고자 하는 문제를 설명해주세요"
            rows={4}
          />
        </div>

        <div className={styles.formGroup}>
          <Textarea
            label="해결방안"
            id="solution"
            name="solution"
            value={formData.solution}
            onChange={handleChange}
            placeholder="문제를 해결하기 위한 방안을 설명해주세요"
            rows={4}
          />
        </div>

        <div className={styles.formGroup}>
          <Textarea
            label="기대효과"
            id="impact"
            name="impact"
            value={formData.impact}
            onChange={handleChange}
            placeholder="이 해결방안을 통해 기대할 수 있는 효과를 설명해주세요"
            rows={4}
          />
        </div>

        <div className={styles.buttons}>
          <Button 
            type="submit" 
            color="primary" 
            width="full-width" 
            size="large"
          >
            수정하기
          </Button>
        </div>
      </form>
    </Modal>
  );
}

export default EditIdeaModal; 